
import { useContext, useState } from 'react';
import './style/helpDesk.css';
import { AppContext } from '../../../contextApi/ContextApi';
import NotFound404 from '../../NotFound404';

export default function HelpDesk({website}) {
  const {primary_color, accent_color, hasHelpdesk} = useContext(AppContext);
  const [isHoverMail, setIsHoverMail] = useState(false);
  if(!hasHelpdesk) return <NotFound404/>
  return (
    <div id='helpDesk_mainContainer'>
      <h1 style={{margin:"50px auto", color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>שירות לקוחות - {website?.settings?.website_name}</h1>
      <div id='helpDeskDiv' style={{margin:"0 auto 100px"}}>
        <h3 style={{textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>מוקד התמיכה - {website?.settings?.phone}</h3>
        <div className="helpDesk_email">
          <h3 style={{textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>אימייל - {website?.settings?.email}</h3>
          <a className='emailIcon_a' onMouseEnter={()=>{setIsHoverMail(true)}} onMouseLeave={()=>{setIsHoverMail(false)}} style={{color:isHoverMail ? primary_color : accent_color}} href={`mailTo:${website.settings.email}?subject=HelpDesk&body=-Write Your Issue Here-`}>✉</a>
        </div>
        {website?.settings?.address !== null && website?.settings?.address !== "" && <h3 style={{textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>כתובת העסק - {website?.settings?.address}</h3>}
      </div>
    </div>
  )
}
